import { Modal, Table, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { serviceCoordinatorColumns } from '../../Consts/TableColumns';
import { GetServiceCoordinators } from '../../Services';
import { useColumnSearch } from '../ColumnSearchProps';

const ServiceTable = ({visibility, setVisibility, handleSubmit}) => {
    const [data, setData] = useState([]);
    const [highlighted, setHighlighted] = useState();
    const [loading, setLoading] = useState(true);
    const { getColumnSearchProps } = useColumnSearch();

    useEffect(() => {
        if(visibility){
            GetServiceCoordinators().then((res) => {
                setData(res?.data);
                setHighlighted(res?.data[0]);
            }).catch(() => {
                message.error('Therapists not retrieved');
            }).finally(() => {
                setLoading(false);
            })
        }
    }, [visibility]);

    const handleRowOnClick = record => {
        setHighlighted(record);
    }

    const handleOnSubmit = () => {
        handleSubmit(highlighted);
        setVisibility(false);
    }

    return(
        <Modal
            title="Service Coordinators"
            open={visibility}
            onCancel={() => setVisibility(false)}
            onOk={() => handleOnSubmit()}
        >
            <Table 
                columns={serviceCoordinatorColumns(getColumnSearchProps)}
                dataSource={data}
                pagination={{ hideOnSinglePage: true }}
                loading={loading}
                rowKey={(record) => record.id}
                rowClassName={record => (highlighted === record ? 'ant-table-row-selected' : '')}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: () => handleRowOnClick(record)
                    }
                }}
            />
        </Modal>
    )
}

export default ServiceTable;